import React, { useState, useEffect } from 'react';
import { Field } from 'formik';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _lowerCase from 'lodash/lowerCase';
import _map from 'lodash/map';
import _orderBy from 'lodash/orderBy';
import { FilterWrapper } from '../../../components/FilterWrapper';
import { Select } from '../../../components/Select';
import { GenericSelectList } from '../../../types/generics';
import { PARTS_NUMBER } from '../../../utils/productType';
import { stores } from './services/stores';

interface FormikValuesType {
  city: any;
  store: any;
}

interface CityType {
  city: string;
  uf: string;
}

interface LocalityType {
  label: string;
  value: string;
}

interface Props {
  title: string;
  values: FormikValuesType;
  setFieldValue: (field: string, e: any) => void;
  getValues: (type: string, values: any) => void;
  hasStore: boolean;
  hasCity: boolean;
  cities: CityType[];
  changeLocality?: () => void;
  showStore?: boolean;
  typeSearch?: number;
}

export const FormStoreCity = ({
  title,
  values,
  setFieldValue,
  getValues,
  hasStore,
  cities,
  hasCity,
  changeLocality,
  showStore = true,
  typeSearch,
}: Props) => {
  const [localities, setLocalities] = useState([{ label: '', value: '' }]);
  const [normalizedLocalities, setNormalizedLocalities] = useState([{ label: '', value: '' }]);
  const [storeOptions, setStoreOptions] = useState<GenericSelectList>();

  useEffect(() => {
    if (!hasStore) {
      setFieldValue('store', null);
    }
    if (!hasCity) {
      setFieldValue('city', null);
    }
  }, [hasStore, hasCity]);

  useEffect(() => {
    const normalized = _map(cities, (city: CityType) => {
      const normalizedCity = `${city.city}-${city.uf}`;

      return {
        label: normalizedCity,
        value: normalizedCity,
      };
    });

    setLocalities(normalized);
    setNormalizedLocalities(normalized);

    if (values.city && hasStore) {
      handleGetStoresByLocality(values.city);
    }
  }, [cities]);

  const handleOnInputChangeLocality = (value: string) => {
    const filteredLocalities = _filter(normalizedLocalities, (locality: LocalityType) =>
      _includes(_lowerCase(locality.value), _lowerCase(value)),
    );

    setLocalities(filteredLocalities);
  };

  const handleGetStoresByLocality = (locality: LocalityType) => {
    const { value } = locality;
    const localitySplited = value.split('-');
    const city = localitySplited[0];
    const state = localitySplited[1];

    stores
      .getStoresByStateCitySearch(state, city)
      .then(res => {
        const mapStores = _map(res.data, store => {
          return {
            label: store.fantasyName || store.companyName,
            value: store.fantasyName || store.companyName,
          };
        });
        setStoreOptions(mapStores);
      })
      .catch(err => err);
  };

  const handleOnChangeLocality = (e: any) => {
    if (e) {
      setStoreOptions([]);
      setFieldValue('city', e);
      getValues('city', e.value);

      if (hasStore) {
        handleGetStoresByLocality(e);
      }
      if (changeLocality) {
        changeLocality();
      }
    }
  };

  const handleOnChangeStore = (e: any) => {
    getValues('fantasyName', e);
    setFieldValue('store', e);
  };

  const renderStoreField = () => {
    if (
      !showStore ||
      !hasCity ||
      !storeOptions ||
      !storeOptions.length ||
      typeSearch === PARTS_NUMBER
    ) {
      return null;
    }

    return (
      <FilterWrapper title="LOJA" titleClass="pb8">
        <Field
          locationDropdown="#sidebar-search"
          name="store"
          id={title + 'store'}
          labeltext="Loja"
          title="Loja"
          value={_get(values, 'store', null)}
          options={_orderBy(storeOptions, 'label', 'asc')}
          onChange={handleOnChangeStore}
          component={Select}
          selected={_get(values, 'store', null)}
        />
      </FilterWrapper>
    );
  };

  return (
    <form>
      <FilterWrapper title="CIDADE" className="mb16" titleClass="pb8">
        <Field
          locationDropdown="#sidebar-search"
          name="city"
          id={title + 'city'}
          labeltext="Cidade"
          title="Cidade"
          value={_get(values, 'city', null)}
          selected={_get(values, 'city', null)}
          options={_orderBy(localities, 'label', 'asc')}
          onChange={handleOnChangeLocality}
          onInputChange={handleOnInputChangeLocality}
          component={Select}
          noDropdownIndicator
        />
      </FilterWrapper>
      {renderStoreField()}
    </form>
  );
};
